module.exports = __webpack_public_path__ + "static/0068-5d0932df8d0a8d980d589a196683b085.png";